import { Component, OnInit, Input } from '@angular/core';
import { GiftCardService } from './gift-card.service';
import { GdprService } from '../gdpr/gdpr.service';
import { ServiceGuard } from '../_guards/service.guard';
import { EnvironmentSpecificService } from '../environs/services/environment-specific.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';

@Component({
  selector: 'app-gift-card',
  templateUrl: './gift-card.component.html',
  styleUrls: ['../app.component.css']
})
export class GiftCardComponent implements OnInit {
  loading = false;
  contactId: number;
  expiredCode: boolean;
  countDown;
  counter = 30 * 60;
  @Input() id: string;

  constructor(private _giftCardService: GiftCardService,
    private gdprService: GdprService, private _serviceGaurd: ServiceGuard,
    private envSpecificSvc: EnvironmentSpecificService, private _router: Router) { }

  getToken() {
    this.gdprService.getToken(this.envSpecificSvc.envSpecific).subscribe((res => {
      this._serviceGaurd.login(res);
    }));
  }
  ngOnInit() {
    this.countDown = Observable.interval(1140000).map((x) => {
      return --this.counter;
    });
    this.countDown.subscribe((x) => this.getToken());
    if (!sessionStorage.getItem('bearer_token')) {
      this.gdprService.getToken(this.envSpecificSvc.envSpecific).subscribe((res => {
        this._serviceGaurd.login(res);
      }),
        err => {
          this.loading = false;
          console.log(err.message);
        });
    }
  }
  getContactByHashCode() {

    this.loading = true;
    this._giftCardService.getContactId(this.envSpecificSvc.envSpecific, this.id).subscribe(data => {
      if (data.records.length > 0) {
        if (!data.records[0].expiredInd) {
          this.contactId = data.records[0].contactId;
          this._router.navigate(['/gdpr'], { queryParams: { contactId: btoa(this.contactId.toString()) } });
          this.loading = false;
          this._serviceGaurd.storeHashcode(this.id);
        } else {
          this.loading = false;
          this._router.navigate(['/error']);
        }
      } else {
        this.loading = false;
        this._router.navigate(['/error']);
      }
    });
  }
}
